<template>
  <Modal :title="'Aggiungi appuntamento'" :openModal="open" @close="$emit('close')" @success="prepareAppointment()" :loading="loadingSave" style="width: 100%; padding: 30px;">
    <div class="columns is-multiline">

      <div class="column is-12-mobile is-6-tablet is-4-desktop">
        <InputSelect
          v-if="call"
          name="Occupante"
          v-model="call.occupant"
          :options="[]"
          placeholder="Occupante"
          :disabled="true"
          id="_id"
          track-by="_id"
          :custom-label="$clientName"
        >
          <a class="button is-warning" :href="call.occupant ? '/clienti/'+call.occupant._id : 'javascript:void(0)'"><font-awesome-icon icon="user" class="m-0" /></a>
        </InputSelect>
      </div>

    </div>

    <WeekCalendar @newAppointment="appointments = [$event]" :canCreate="true" :canEdit="false" />
  </Modal>
</template>

<script>
export default {
  props: ['call', 'open'],

  emits: ['saved', 'close'],

  data() {
    return {
      appointments: [],
      newOperation: {},
      loadingSave: false
    }
  },

  methods: {
    prepareAppointment() {
      
      this.loadingSave = true

      if (this.call.client) {
        this.newOperation = {
          client: this.call.client,
          occupant: this.call.occupant,
          place: this.call.place,
          implant: this.call.implant
        }

        this.saveAppointment()
      } else {
        this.createClientPlace(this.saveAppointment)
      }
    },

    saveAppointment() {
      const self = this

      this.newOperation.reception_date = this.call.date
      this.newOperation.appointment_date = this.appointments[0].appointment_date,
      this.newOperation.appointment_start = this.appointments[0].appointment_start,
      this.newOperation.appointment_end = this.appointments[0].appointment_end,
      this.newOperation.operators = this.appointments[0].operators[0]
      this.newOperation.notes_office = this.call.notes
      this.newOperation.type = this.call.type
      this.newOperation.call = this.call._id
      this.newOperation.archived_notes = this.call.archived_notes

      this.$http.post('/operation', {...this.newOperation})
      .then(function (response) {
        const id_operation = response.data._id

        let params = {
          operation: id_operation
        }

        if (!self.call.client) {
          params.tempClient = {}
          params.client = self.newOperation.client
          params.occupant = self.newOperation.occupant

          if (self.newOperation.place) {
            params.place = self.newOperation.place
          }

          if (self.newOperation.implant) {
            params.implant = self.newOperation.implant
          }
        }

        self.$http.put('/call/' + self.call._id, params)
        .then(function (response) {
          self.loadingSave = false
          self.$emit('saved', id_operation)
          self.newOperation = {}
        })
        .catch(function (error) {
          console.log(error)
          alert('Errore')
          self.loadingSave = false
        })
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.loadingSave = false
      })
    },

    createClientPlace(callback) {
      const self = this
      const installerLabel = this.getInstallerLabel()

      this.$http.post('/client', {
        name: this.call.tempClient.name,
        surname: this.call.tempClient.surname,
        business_name: this.call.tempClient.business_name,
        city: this.call.tempClient.city_residence,
        address: this.call.tempClient.address_residence,
        floor: this.call.tempClient.floor_residence,
        interior: this.call.tempClient.interior_residence,
        zip: this.call.tempClient.zip_residence,
        contacts: this.call.tempClient.contacts
      })
      .then(function (response) {
        const newClient = response.data

        self.$http.post('/place', {
          city: self.call.tempClient.city,
          address: self.call.tempClient.address,
          floor: self.call.tempClient.floor,
          interior: self.call.tempClient.interior,
          zip: self.call.tempClient.zip,
          client: newClient._id
        })
        .then(function (response) {
          const newPlace = response.data

          self.$http.post('/implant', {
            generator_thermals: [{
              brand: self.call.tempClient.brand,
              model: self.call.tempClient.model,
              installer: installerLabel,
            }],
            occupant: newClient._id,
            client: newClient._id,
            place_occupant: newPlace._id
          })
          .then(function (response) {
            const newImplant = response.data

            self.newOperation = {
              client: newClient._id,
              occupant: newClient._id,
              place: newPlace._id,
              implant: newImplant._id
            }

            if (self.call.tempClient.name_owner || self.call.tempClient.surname_owner || self.call.tempClient.business_name_owner) {
              self.$http.post('/client', {
                name: self.call.tempClient.name_owner,
                surname: self.call.tempClient.surname_owner,
                business_name: self.call.tempClient.business_name_owner,
              })
              .then(function (response) {
                const newOwner = response.data

                self.$http.put('/implant/' + newImplant._id, {
                  client: newOwner._id
                })
                .then(function (response) {
                  self.newOperation.client = newOwner._id

                  callback()
                })
                .catch(function (error) {
                  console.log(error)
                  alert('Errore')
                })
              })
              .catch(function (error) {
                console.log(error)
                alert('Errore')
              })
            } else {
              callback()
            }
          })
          .catch(function (error) {
            console.log(error)
            alert('Errore')
          })
        })
        .catch(function (error) {
          console.log(error)
          alert('Errore')
        })
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
    },

    getInstallerLabel() {
      const installer = this.call?.tempClient?.installer

      if (!installer) {
        return ''
      }

      if (typeof installer === 'string') {
        return ''
      }

      return this.$clientName(installer)
    }
  }
}
</script>